import { render } from "./ModalwindowComponent.vue?vue&type=template&id=3017a61a"
import script from "./ModalwindowComponent.vue?vue&type=script&lang=js"
export * from "./ModalwindowComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__